var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplyActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11234",
    "data-name": "Path 11234",
    d: "M20.477,14.1a5.769,5.769,0,0,1-5.769-5.769,5.388,5.388,0,0,1,.058-.8,2.885,2.885,0,1,1,3.34-4.454,5.8,5.8,0,0,1,4.742,0,2.85,2.85,0,0,1,2.244-1.1,2.885,2.885,0,0,1,1.1,5.55,5.388,5.388,0,0,1,.058.8A5.769,5.769,0,0,1,20.477,14.1ZM15.862,3.142A1.738,1.738,0,1,0,15.539,6.6l.577.115-.138.577a4.523,4.523,0,0,0-.115,1.038,4.615,4.615,0,0,0,9.231,0,4.846,4.846,0,0,0-.127-1.062L24.827,6.7l.577-.115A1.731,1.731,0,1,0,23.546,4.1l-.271.537-.49-.3a4.685,4.685,0,0,0-4.569,0l-.525.3L17.419,4.1A1.731,1.731,0,0,0,15.862,3.142Z",
    transform: "translate(-5.477 -0.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3728",
    "data-name": "Rectangle 3728",
    width: 2,
    height: 2,
    transform: "translate(14 9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3729",
    "data-name": "Rectangle 3729",
    width: 2,
    height: 1,
    transform: "translate(14 8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3730",
    "data-name": "Rectangle 3730",
    width: 1,
    height: 2,
    transform: "translate(12 6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3731",
    "data-name": "Rectangle 3731",
    width: 1,
    height: 2,
    transform: "translate(17 6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11235",
    "data-name": "Path 11235",
    d: "M31.687,43.255a4.229,4.229,0,0,1-1.835-.45c-2.238-1.085-2.885-3.352-1.621-5.913s3.4-3.462,5.648-2.394,2.885,3.352,1.621,5.913h0C34.606,42.257,33.228,43.255,31.687,43.255Zm.34-8.077c-1.437,0-2.308,1.292-2.758,2.2-.577,1.154-1.154,3.277,1.09,4.373s3.537-.692,4.1-1.858,1.154-3.277-1.085-4.373A3.144,3.144,0,0,0,32.028,35.178Z",
    transform: "translate(-11.674 -14.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11236",
    "data-name": "Path 11236",
    d: "M14.183,43.219a4.689,4.689,0,0,1-3.554-1.967,5.192,5.192,0,0,1-1.31-3.075,3.75,3.75,0,0,1,1.5-3.052,3.733,3.733,0,0,1,3.288-.877,5.192,5.192,0,0,1,2.763,1.881,5.192,5.192,0,0,1,1.31,3.075,3.75,3.75,0,0,1-1.5,3.052A3.917,3.917,0,0,1,14.183,43.219Zm-.865-7.91a2.792,2.792,0,0,0-1.765.7,2.619,2.619,0,0,0-1.079,2.129,4.038,4.038,0,0,0,1.05,2.377c.819,1,2.487,2.44,4.425.848a2.619,2.619,0,0,0,1.079-2.106,4.038,4.038,0,0,0-1.05-2.377A4.038,4.038,0,0,0,13.849,35.4a2.117,2.117,0,0,0-.531-.087Z",
    transform: "translate(-3.943 -14.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11237",
    "data-name": "Path 11237",
    d: "M22.783,31.491a.577.577,0,0,1-.41-.167,18.652,18.652,0,0,0-1.685-1.454c-1.067-.842-1.99-1.563-2.238-2.763A2.683,2.683,0,0,1,18.907,25a2.412,2.412,0,0,1,1.69-1.01,2.8,2.8,0,0,1,2.187.75,2.8,2.8,0,0,1,2.187-.75h0a2.412,2.412,0,0,1,1.69.992,2.683,2.683,0,0,1,.456,2.106c-.254,1.2-1.154,1.921-2.238,2.763a18.652,18.652,0,0,0-1.685,1.454A.577.577,0,0,1,22.783,31.491Zm-1.9-6.346h-.156a1.246,1.246,0,0,0-.883.525,1.5,1.5,0,0,0-.26,1.206c.167.79.86,1.338,1.823,2.094.427.34.894.71,1.379,1.154.485-.444.952-.813,1.379-1.154.963-.756,1.656-1.3,1.823-2.094a1.5,1.5,0,0,0-.26-1.188,1.246,1.246,0,0,0-.883-.542h0a1.558,1.558,0,0,0-1.535.773.577.577,0,0,1-1.05,0A1.558,1.558,0,0,0,20.88,25.145Z",
    transform: "translate(-7.783 -10.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11238",
    "data-name": "Path 11238",
    d: "M24.993,43.124c-.462,0-.923,0-1.373-.04l.069-1.154a21.2,21.2,0,0,0,2.775,0l.081,1.154C26.043,43.124,25.518,43.124,24.993,43.124Z",
    transform: "translate(-9.993 -17.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11239",
    "data-name": "Path 11239",
    d: "M34.819,34.328a.577.577,0,0,1-.577-.444,1.413,1.413,0,0,0-.577-.825.577.577,0,0,1,.7-.912,2.556,2.556,0,0,1,.963,1.471.577.577,0,0,1-.4.71A.49.49,0,0,1,34.819,34.328Z",
    transform: "translate(-14.16 -13.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11240",
    "data-name": "Path 11240",
    d: "M36.277,29.892l-.392-1.085a1.765,1.765,0,0,0,1.085-.837,2.5,2.5,0,0,0-.115-1.887c-.513-1.362-2.648-4.713-5.654-5.81l.392-1.085c3.415,1.246,5.769,4.91,6.346,6.49a3.525,3.525,0,0,1,.115,2.775A2.885,2.885,0,0,1,36.277,29.892Z",
    transform: "translate(-13.2 -8.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11241",
    "data-name": "Path 11241",
    d: "M15.739,34.4h-.115a.577.577,0,0,1-.45-.663,2.573,2.573,0,0,1,.987-1.575.577.577,0,1,1,.7.912,1.408,1.408,0,0,0-.577.888A.577.577,0,0,1,15.739,34.4Z",
    transform: "translate(-6.416 -13.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11242",
    "data-name": "Path 11242",
    d: "M10.562,29.892a2.885,2.885,0,0,1-1.731-1.437,3.525,3.525,0,0,1,.115-2.775c.577-1.581,2.925-5.244,6.346-6.49l.392,1.085c-3.035,1.113-5.169,4.448-5.7,5.81a2.5,2.5,0,0,0-.15,1.887,1.771,1.771,0,0,0,1.079.837Z",
    transform: "translate(-3.639 -8.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3732",
    "data-name": "Rectangle 3732",
    width: 30,
    height: 30,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyActive);
export default __webpack_public_path__ + "static/media/supply-Active.db95664b2125146d838a6f2b87983ac6.svg";
export { ForwardRef as ReactComponent };